import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import {CardContent, CardHeader, Typography} from '@mui/material'
import Card from '@mui/material/Card'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

function createData(feature: string, free: any, single: any, standard: any, premium: any) {
  return {feature, free, single, standard, premium}
}

const rows = [
  createData(
    'Personal Profile Management',
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />
  ),
  createData(
    'Business Profile Management',
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />
  ),
  createData(
    'Business and People Directory Keyword Search',
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />
  ),
  createData(
    'AI search with custom-tailored graph concepts',
    <></>,
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />
  ),
  createData(
    'Opportunity Notifications',
    <></>,
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />
  ),
  createData(
    'Track Favorite Businesses and Profiles',
    <></>,
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />
  ),
  createData(
    'Projects for Scouting Evaluations',
    <></>,
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />
  ),

  createData(
    'Add Notes and Documents to Projects, Businesses, etc.',
    <></>,
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />
  ),
  createData('Project Sharing', <></>, <></>, <CheckCircleIcon />, <CheckCircleIcon />),
  createData(
    'Customer Support',
    <></>,
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />
  ),
  createData('Personalized Training', <></>, <></>, <></>, <CheckCircleIcon />),
  createData('Scouting Exericse Support', <></>, <></>, <></>, <CheckCircleIcon />),
  createData('Semi-Annual Improvement program', <></>, <></>, <></>, <CheckCircleIcon />),
  createData('Technical Assistance/training needs', <></>, <></>, <></>, <CheckCircleIcon />),
  createData(
    'New Features and Upgrades',
    <></>,
    <CheckCircleIcon />,
    <CheckCircleIcon />,
    <CheckCircleIcon />
  ),
  createData('Customer Succes Specialist', <></>, <></>, <></>, <CheckCircleIcon />),
]

export default function PricingTable({
  handleRegisterRoute,
}: {
  handleRegisterRoute: (type: string) => void
}) {
  return (
    <Card elevation={1} sx={{flex: '1', p: 1, mt: 1, mr: 1}}>
      <CardHeader
        title={<Typography variant={'h5'}>Subscription Plan Features</Typography>}
      ></CardHeader>
      <CardContent>
        <Table>
          <TableBody>
            <TableRow sx={{flex: '1', alignContent: 'center', alignItems: 'center'}}>
              <TableCell align='left' width={'28%'}>
                <Typography variant={'h5'}>Features</Typography>
              </TableCell>
              <TableCell align='center' width={'18%'}>
                <Typography variant={'h6'}>Free</Typography>
              </TableCell>
              <TableCell align='center' width={'18%'}>
                <Typography variant={'h6'}>Single User</Typography>
              </TableCell>
              <TableCell align='center' width={'18%'}>
                <Typography variant={'h6'}>Standard</Typography>
              </TableCell>
              <TableCell align='center' width={'18%'}>
                <Typography variant={'h6'}>Premium</Typography>
              </TableCell>
            </TableRow>
            {rows.map((row) => (
              <TableRow
                key={row.feature}
                sx={{
                  flex: '1',
                }}
              >
                <TableCell width={'28%'}>
                  <Typography variant={'body1'}>{row.feature}</Typography>
                </TableCell>
                <TableCell align='center' width={'18%'}>
                  <Typography variant={'body1'}>{row.free}</Typography>
                </TableCell>
                <TableCell align='center' width={'18%'}>
                  <Typography variant={'body1'}>{row.single}</Typography>
                </TableCell>
                <TableCell align='center' width={'18%'}>
                  <Typography variant={'body1'}>{row.standard}</Typography>
                </TableCell>
                <TableCell align='center' width={'18%'}>
                  <Typography variant={'body1'}>{row.premium}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )
}
